import Grid from "@mui/material/Grid";
import {
  Button,
  Card,
  CardContent,
  Chip,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Clear, Search, Visibility } from "@mui/icons-material";
import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

const teacherName = (teacher) =>
  teacher.user?.fullName || "Unavailable teacher";

export function TeacherSummary({
  teacher,
  onViewClicked,
  onUnassignClicked = null,
}) {
  return (
    <Card variant={"outlined"} data-testid={`teacher-summary-${teacher.id}`}>
      <CardContent>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Typography variant={"subtitle1"}>{teacherName(teacher)} </Typography>
          {onUnassignClicked && (
            <Button
              endIcon={<Clear />}
              variant="card-action"
              onClick={() => onUnassignClicked(teacher)}
            >
              Unassign
            </Button>
          )}
        </Stack>
        <Stack direction={"row"} spacing={2} sx={{ mt: 1, mb: 2 }}>
          <Typography variant={"subtitle2"}>School: </Typography>
          <Chip label={teacher.school.name} sx={{ mt: 1, mb: 1 }} />
        </Stack>
        <Stack
          direction={"row"}
          sx={{ width: "100%" }}
          spacing={2}
          justifyContent={"flex-end"}
        >
          <Button
            variant={"outlined"}
            startIcon={<Visibility />}
            disabled={!teacher.user}
            onClick={() => onViewClicked(teacher)}
          >
            View
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
}

export const FruitifyTeacherSearch = ({ teachers }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const filteredTeachers = useMemo(() => {
    return teachers.filter((t) => {
      const matchesSearch = teacherName(t)
        .toLowerCase()
        .includes(searchTerm.toLowerCase());

      return matchesSearch;
    });
  }, [teachers, searchTerm]);

  return (
    <Grid
      container
      spacing={2}
      sx={{ width: "100%", mt: 2 }}
      data-testid={"fruitify-teacher-search"}
    >
      {/* Each tab has the search + results */}
      <Grid size={12} sx={{ mt: 2 }}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          sx={{ width: "100%", mb: 2 }}
        >
          <TextField
            label="Search"
            variant="outlined"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Search />
                </InputAdornment>
              ),
            }}
            sx={{ width: { xs: "100%", sm: 280 } }}
          />
        </Stack>
      </Grid>
      {filteredTeachers?.map((teacher) => (
        <Grid size={{ xs: 12, md: 4 }} key={teacher.id}>
          <TeacherSummary
            teacher={teacher}
            onViewClicked={(teacher) => navigate(`view/${teacher.id}`)}
          />
        </Grid>
      ))}
    </Grid>
  );
};
